import { render, staticRenderFns } from "./ModelXSpecs.vue?vue&type=template&id=a4896f3c&scoped=true&"
import script from "./ModelXSpecs.vue?vue&type=script&lang=js&"
export * from "./ModelXSpecs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4896f3c",
  null
  
)

export default component.exports